/*
Round Grommets

  --diameter <float> | inches
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Round'
const id = 'E7rV6GSMd3sS2zi52HWY'

export default {
  name,
  id,
  filters,
  headers,
  form
}
